module.exports = __webpack_public_path__ + "img/compax-white.20009624.png";